// extracted by mini-css-extract-plugin
export default {"zoomModal":"z2-z"};